import OrdemServicoItemService from "@/services/OrdemServicoItemService";

export const ordemServicoItem = {
  namespaced: true,
  state: {
    ordemServicoItem: {},
  },
  actions: {
    getOrdemServicoItem({ commit }, payload) {
      return OrdemServicoItemService.GetOrdemServicoItem(payload).then(
        (ordemServicoItem) => {
          return Promise.resolve(ordemServicoItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postOrdemServicoItem({ commit }, payload) {
      return OrdemServicoItemService.PostOrdemServicoItem(payload).then(
        (ordemServicoItem) => {
          return Promise.resolve(ordemServicoItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putOrdemServicoItem({ commit }, payload) {
      return OrdemServicoItemService.PutOrdemServicoItem(payload).then(
        (ordemServicoItem) => {
          return Promise.resolve(ordemServicoItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteOrdemServicoItem({ commit }, payload) {
      return OrdemServicoItemService.DeleteOrdemServicoItem(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getOrdemServicoItemOData({ commit }, payload) {
      return OrdemServicoItemService.GetOrdemServicoItemOData(payload).then(
        (ordemServicoItem) => {
          return Promise.resolve(ordemServicoItem);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default ordemServicoItem;
